import { forwardRef } from 'react'
import PropTypes from 'prop-types'

import Icon from './Icon'

const Checkbox = forwardRef(
  ({ className, wrapperClassName, labelClassName, label, ...props }, ref = null) => {
    return (
      <label className={`flex items-center cursor-pointer ${wrapperClassName}`}>
        <input
          type="checkbox"
          className={`appearance-none p-0 m-0 b-0 peer`}
          {...props}
          ref={ref}
        />

        <span
          className={`w-4 h-4 !mr-2 relative border !border-primary-75 rounded-[4px] bg-white-50 text-transparent peer-checked:!text-primary-75 inline-flex items-center justify-center ${className}`}
        >
          <Icon
            name="check-mark"
            className="w-[15px] h-[15px] transition-colors duration-200 ease"
          />
        </span>

        <span className={`select-none ${labelClassName}`}>{label}</span>
      </label>
    )
  }
)

Checkbox.defaultProps = {
  className: '',
  wrapperClassName: '',
  labelClassName: '',
}
Checkbox.propTypes = {
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
}
Checkbox.displayName = 'CheckboxUI'

export default Checkbox
